import parse from 'html-react-parser';
import { FC } from 'react';

interface AboutContentProps {
  contentHtml: string;
}

const AboutContent: FC<AboutContentProps> = ({ contentHtml }) => (
  <article className="landing-page">{parse(contentHtml)}</article>
);

export default AboutContent;
